export const LABEL_TEXT = "Sub delivery";
export const TOOLTIP_TEXT = `A sub delivery is connected to larger campaign or delivery.
Example: "Happy Days" and "Plant ball" are sub deliveries to the main delivery name "IKEA Food".`;
